import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ArrUtil, Dataset, DatasetRepo, Dimension } from '@gspwidget/util';
import { FilterComponent } from '@gspwidget/widget-core';
import { FilterSchema, FSEnum, FSEnumItem, FSEnumSource, FSLastTimeItem } from '@gspwidget/widget-devkit';

@Component({
  selector: 'lib-fe-filter-modal',
  templateUrl: './fe-filter-modal.component.html',
  styleUrls: ['./fe-filter-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeFilterModalComponent implements OnInit {
  // @Input() getIntactData: () => Observable<any[]> = defaultGetIntactData
  // @Input() dims: Dimension[]
  @Input('filterSchema') fs = new FilterSchema()
  @ViewChild(FilterComponent) filterComp: FilterComponent

  ArrUtil = ArrUtil
  /**
   * ç¨äºè·å items çæ°æ®ï¼æªç»ç­éã
   * æå¼æ­¤ modal åï¼ç¬¬ä¸æ¬¡åæ¢å° enum.source==='dataField' æ¶å è½½æ­¤æ°æ®ã
   */
  intactData: any[] = null
  /**
   * intactData + valueField + labelField
   * å¾å°çå¨é¨ itemsï¼éæç»éä¸­çã
   * éä¸­çå­å¨ fs.enum.itemsFromDataã
   */
  allItemsFromData: FSEnumItem[] = []
  /**
   * ç¨ä½åæ¬¡æå¼ç¼è¾å¨æ¶ï¼å±ç¤ºå·²éä¸­ç itemsã
   * å­çæ¯ itemsï¼è¦çæ¯ valuesï¼æä»¥éè¦å¨åå§åæ¶è½¬æ¢ä¸æ¬¡ã
   */
  selectedItemsValue: any[]
  /** ä»ç¨äºçº¯åç«¯æå­å½å item source datasetï¼æ¾ç¤ºå¨é¡µé¢ä¸ */
  curFsEnumDataset: Dataset
  curEnumItems: any[]
  curItemsDatasetResult: any[]

  constructor (
    public datasetRepo: DatasetRepo,
    public cd: ChangeDetectorRef,
  ) { }

  ngOnInit () {
    // this.handleChangeEnumSource()
    this.checkNUpdateEnum()
  }

  /** 1. type change */
  handleChangeType () {
    this.checkNUpdateEnum()
  }
  /** date */
  handleAddLastTimeItem () {
    ArrUtil.Add(this.fs.date.lastTimeItems, new FSLastTimeItem())
  }
  handleAddEnumItem () {
    ArrUtil.Add(this.fs.enum.itemsManual, new FSEnumItem())
  }
  /** 2. enum source change */
  handleChangeEnumSource () {
    // if (!this.curFsEnumDataset) {
    //   this.updateDatasetResult()
    // }
    this.checkNUpdateEnum()
  }
  /** 3. enum dataset change */
  handleChangeItemsDataset (flawDataset: Dataset) {
    this.fs.enum.itemsDatasetId = flawDataset.id
    // åï¼âæ°æ®éåè¡¨âæ¥å£ä¸­ dims å¨ä¸ºç©ºï¼æä»¥ç§°ä¸º flaw datasetã
    // æä»¥ååç¬è¯·æ±ä¸æ¬¡å§ã
    this.updateDatasetResult()
  }
  /** 4. dataset enum field change */
  handleItemFieldChange () {
    this.updateDatasetEnumItems()
  }
  /**
   * A.
   * æ£æ¥æ¯å¦éè¦è§¦å Bãè°ç¨æ¶æºï¼
   * 1. åå§åæ¶
   * 2. fs.type ååæ¶
   * 3. fs.enum.source ååæ¶
   * éè¦è°ç¨
   */
  private checkNUpdateEnum () {
    const { type, enum: fsEnum } = this.fs
    const { source } = fsEnum
    if (type !== 'enum') return
    if (source === 'manual') {
      this.setCurEnumItems(this.fs.enum.itemsManual)
    } else if (source === 'dataset') {
      if (!this.curItemsDatasetResult) {
        this.updateDatasetResult()
      } else {
        this.updateDatasetEnumItems()
      }
    }
  }
  /**
   * B.
   * è¯·æ±ãæ´æ° dataset æ°æ®éæ¬ä½ãæç»æ°æ®ç­ãè°ç¨æ¶æºï¼
   * 1. A
   * 2. dataset åæ¢æ¶
   */
  private updateDatasetResult () {
    if (
      this.fs.enum.source !== 'dataset'
      || !this.fs.enum.itemsDatasetId
    ) return

    this.datasetRepo.getDatasetById(this.fs.enum.itemsDatasetId).subscribe(dataset => {
      this.curFsEnumDataset = dataset
      this.cd.markForCheck()
    })
    this.datasetRepo.getResultByDatasetId(this.fs.enum.itemsDatasetId).subscribe(res => {
      this.curItemsDatasetResult = res
      this.updateDatasetEnumItems()
      this.cd.markForCheck()
    })
  }
  /**
   * C.
   * ç¨ result éæ°å¾å° dataset itemsï¼è°ç¨æ¶æºï¼
   * 1. A.
   * 2. B.
   * 3. field åæ¢æ¶
   */
  private updateDatasetEnumItems () {
    if (!this.curItemsDatasetResult) return
    this.setCurEnumItems(
      this.curItemsDatasetResult.map(item => ({
        label: item[this.fs.enum.itemsLabelField],
        value: item[this.fs.enum.itemsValueField],
      }))
    )
  }
  private setCurEnumItems (enumItems: FSEnumItem[]) {
    this.curEnumItems = enumItems
    // this.filterComp.setEnumItems(enumItems)
    this.cd.markForCheck()
  }

}
